import React from 'react';
import { Box } from '../../base/Box/Box';
import { ContentCarouselSectionStoryblok } from '../../types/storyblok';
import { Type } from '../../base/Type/Type';
import { Splide, SplideTrack } from '@splidejs/react-splide';
import renderStoryblokComponents from '../../utils/renderStoryblokComponents';
import { Button } from '../../base/Button/Button';

export const ContentCarouselSection = ({
  heading,
  cards,
  linkTitle,
  link,
  colourScheme = 'white',
  overlayOverBkg,
}: ContentCarouselSectionStoryblok) => {
  if (!heading && !cards && !linkTitle && !link) {
    return null;
  }

  return (
    <Box
      as="section"
      colourScheme={colourScheme || 'white'}
      bkg
      overlayOverBkg={overlayOverBkg}
    >
      <Splide
        hasTrack={false}
        aria-label={`${heading} carousel`}
        options={{
          type: 'loop',
          gap: '3rem',
          padding: 'calc((1rem / 4) * 5)',
          snap: true,
          mediaQuery: 'min',
          pagination: false,
          focus: 'center',
          breakpoints: {
            768: {
              padding: '10%',
            },
          },
        }}
      >
        <Box
          as="div"
          className="mx-auto mb-6 flex max-w-standard flex-row items-center justify-between gap-6 md:mb-12"
          blockSpacing
        >
          <Type as="h2" className="text-h5 uppercase">
            {heading}
          </Type>
          <Box
            as="div"
            className="splide__arrows flex flex-row gap-6 md:items-end"
          >
            <Button
              type="button"
              variant="arrow-left"
              className="splide__arrow splide__arrow--prev"
            />
            <Button
              type="button"
              variant="arrow-right"
              className="splide__arrow splide__arrow--next"
            />
          </Box>
        </Box>
        <Box as="div" className="custom-wrapper">
          <SplideTrack>
            {renderStoryblokComponents({ blocks: cards })}
          </SplideTrack>
        </Box>
      </Splide>
    </Box>
  );
};

export default ContentCarouselSection;
